import { AxiosInstance } from 'axios';
import { handleErrorExcept403, handleFailToast } from '../utils/errorHandler';
import { t } from 'i18next';
import { signOut } from 'firebase/auth';

const applyResponseInterceptor = (instance: AxiosInstance, config: any, auth: any) => {
  instance.interceptors.response.use(
    (response) => {
      if (config.useLoading) {
        // setLoading(false);
      }
      return response;
    },
    (error) => {
      if (config.useLoading) {
        // setLoading(false);
      }
      const isNotExistUser = checkIsNotExistUser({
        statusCode: error.response.data.statusCode,
        errorCode: error.response.data.code,
      });

      if (isNotExistUser) {
        const cookieDomain = import.meta.env.VITE_APP_COOKIE_DOMAIN;
        removeTokenCookie(cookieDomain);
        signOut(auth);
        localStorage.removeItem('isCustomLogin');
        throw error;
        // console.log(import.meta.env, process.env, cookieDomain);
      }

      // TODO : 로그인/로그아웃 로직 적용할 때 주석 제거 필요
      // if (config.useRedirectAndLogout) logout();
      if (config.useErrorToast) handleFailToast(error.message);
      if (!error.response) {
        handleFailToast(t('GENERAL_ERROR_MESSAGE'));
        throw error;
      }

      if (error.response.status >= 500) throw error;

      handleErrorExcept403(error);

      throw error;
    }
  );
};

const checkIsNotExistUser = ({ statusCode, errorCode }: { statusCode: number; errorCode: string }) => {
  if (statusCode === 404 && errorCode === 'NOT_EXIST_USER') {
    return true;
  }
  if (statusCode === 403 && errorCode === 'NON_EXISTENT_USER') {
    return true;
  }
  return false;
};

const removeTokenCookie = (domain: string) => {
  document.cookie = `auth_token=; domain=${domain}; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
};

export { applyResponseInterceptor };
